import { Coordinate } from "client/Misc/commonTypes";
import { ReactElement } from "react";
import { VisibilityActionState } from "./VisibilityActionButton";
import {
	ActionListItem,
	DropOverActionList,
	FontIconName
} from "client/Components";
import { localize } from "client_legacy/ndaw/culture";

export type VisibilityActionMenuProps = {
	target: HTMLElement;
	position: Coordinate;
	visibilityState: VisibilityActionState;
	onToggleVisibility: () => void;
	onClose: () => void;
	trackingId: string;
};

export const VisibilityActionMenu = (props: VisibilityActionMenuProps): ReactElement => {
	const {
		target,
		position,
		visibilityState,
		onToggleVisibility,
		onClose,
		trackingId
	} = props;

	return (
		<DropOverActionList
			target={target}
			menuTitle={localize("_Visibility")}
			targetAlignment={{
				kind: "absolute",
				coordinate: position
			}}
			onClose={onClose}
			trackingId={trackingId}
			closeOnMouseDown
		>
			<ActionListItem
				text={localize(stateToLocalizationKey[visibilityState])}
				icon={stateToIcon[visibilityState]}
				onClick={onToggleVisibility}
			/>
		</DropOverActionList>
	);
};
VisibilityActionMenu.displayName = "VisibilityActionMenu";

const stateToIcon: { [key in VisibilityActionState]: FontIconName; } = {
	"visible": "eye-slash",
	"hidden": "eye"
};

const stateToLocalizationKey: { [key in VisibilityActionState]: LocalizationKey; } = {
	"visible": "_HideLibrary",
	"hidden": "_ShowLibrary"
};
